<script>
    export default {
        data() {
            return {
                cardMode: 'card-mode',
                flowerCardMode: 'grid-mode',
                cardWrapClass: '',
                cardClass: ''
            }
        },
        mounted() {
            window.addEventListener('resize', () => {
                if(window.innerWidth >= 768){
                    this.defaultValue();
                }
            });
        },
        methods: {
            defaultValue() {
                this.cardMode = 'card-mode';
                this.flowerCardMode = 'grid-mode',
                this.cardWrapClass = '';
                this.cardClass = '';
            },
            changeCardMode() {
                if (this.cardMode == 'card-mode') {
                    this.cardClass = 'card-sm-row'
                    this.cardMode = 'row-mode';
                } else if (this.cardMode == 'row-mode') {
                    this.cardWrapClass = 'col-6'
                    this.cardClass = 'card-xl'
                    this.cardMode = 'grid-mode';
                } else if (this.cardMode == 'grid-mode') {
                    this.cardWrapClass = ''
                    this.cardClass = ''
                    this.cardMode = 'card-mode';
                }
            },
            changeFlowerCardMode() {
                if(this.flowerCardMode == 'card-mode') {
                    this.flowerCardMode = 'grid-mode'
                } else if (this.flowerCardMode == 'grid-mode') {
                    this.flowerCardMode = 'card-mode'
                }
            }
        }
    }
</script>